// extracted by mini-css-extract-plugin
export default {"lds-heart":"style_lds-heart__404v1","div-after":"style_div-after__kpvWH","div-before":"style_div-before__m8mAc"};